<template>
  <v-card class="elevation-0">
    <v-row class="pa-0 ma-0">
      <v-col cols="6">
        <v-card>
          <v-img
            class="align-end text-white"
            height="200"
            src="stats-preview.jpg"
            contain
          />
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <HelpFormInput
                  v-model="visitorsPerDay"
                  label="Visitors Per Day"
                  placeholder="Visitors Per Day"
                  help-text="The number of visitors per day."
                  :rules="rules.visitorsPerDay"
                  @update:model-value="
                    (v) =>
                      onUpdate({
                        ...modelValue,
                        visitorsPerDay: v,
                      })
                  "
                />
                <HelpFormInput
                  v-model="reachPerDay"
                  label="Reach Per Day"
                  placeholder="Reach Per Day"
                  help-text="The number of reach per day."
                  :rules="rules.reachPerDay"
                  @update:model-value="
                    (v) =>
                      onUpdate({
                        ...modelValue,
                        reachPerDay: v,
                      })
                  "
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <HelpFormInput
                  v-model="visitorsPerMonth"
                  label="Visitors Per Month"
                  placeholder="Visitors Per Month"
                  help-text="The number of visitors per month."
                  :rules="rules.visitorsPerMonth"
                  @update:model-value="
                    (v) =>
                      onUpdate({
                        ...modelValue,
                        visitorsPerMonth: v,
                      })
                  "
                />
                <HelpFormInput
                  v-model="reachPerMonth"
                  label="Reach Per Month"
                  placeholder="Reach Per Month"
                  help-text="The number of reach per month."
                  :rules="rules.reachPerMonth"
                  @update:model-value="
                    (v) =>
                      onUpdate({
                        ...modelValue,
                        reachPerMonth: v,
                      })
                  "
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
      
      
      
      
      <script>
import HelpFormInput from "../../atoms/common/inputs/HelpFormInput.vue";

export default {
  name: "InventoryItemStats",
  components: {
    HelpFormInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        visitorsPerDay: 0,
        visitorsPerMonth: 0,
        reachPerDay: 0,
        reachPerMonth: 0,
      }),
    },
  },
  emits: ["next", "update:modelValue"],
  data() {
    return {
      visitorsPerDay: 0,
      visitorsPerMonth: 0,
      reachPerDay: 0,
      reachPerMonth: 0,
      rules: {
        visitorsPerDay: [
          (v) => !!v || "Visitors per day is required",
          (v) => /^\d+$/.test(v) || "Visitors per day must be a number",
          (v) => v > 0 || "Visitors per day must be greater than 0",
        ],
        visitorsPerMonth: [
          (v) => !!v || "Visitors per month is required",
          (v) => /^\d+$/.test(v) || "Visitors per month must be a number",
          (v) => v > 0 || "Visitors per month must be greater than 0",
        ],
        reachPerDay: [
          (v) => !!v || "Reach per day is required",
          (v) => /^\d+$/.test(v) || "Reach per day must be a number",
          (v) => v > 0 || "Reach per day must be greater than 0",
        ],
        reachPerMonth: [
          (v) => !!v || "Reach per month is required",
          (v) => /^\d+$/.test(v) || "Reach per month must be a number",
          (v) => v > 0 || "Reach per month must be greater than 0",
        ],
      },
    };
  },
  computed: {},

  created() {},
  methods: {
    onUpdate(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>